import { combineReducers } from '@reduxjs/toolkit';

import { reducer as classes } from './classes';
import { reducer as archived_class } from './archived_class';
import { reducer as class_user } from './class_user';
import { reducer as class_topic } from './class_topic';
import { reducer as week_topic } from './week_topic';
import { reducer as class_topic_content } from './class_topic_content';
import { reducer as user_assignment_file } from './user_assignment_file';
import { reducer as question } from './question';
import { reducer as homework_comment } from './homework_comment';
import { reducer as note } from './note';
import { reducer as discussion } from './discussion';
import { reducer as discussionReply } from './discussionReply';
import { reducer as directory } from './directory';
import { reducer as role } from './role';
import { reducer as faq } from './faq';
import { reducer as faq_category } from './faq_category';
import { reducer as tag } from './tag';
import { reducer as user_notification } from './user_notification';
import { reducer as homework_reply_comment } from './homework_reply_comment';
import { reducer as payment_method_detail } from './payment_method_detail';
import { reducer as module_quiz } from './module_quiz';
import { reducer as feedback } from './feedback';
import { reducer as final_assessment } from './final_assessment';
import { reducer as pager_fields } from './pager_fields';
import { reducer as user_pager } from './user_pager';
import { reducer as pager_document } from './pager_document';
import { reducer as company } from './company';
import { reducer as industry } from './industry';
import { reducer as class_user_status } from './class_user_status';

export default combineReducers({
  classes,
  archived_class,
  class_user,
  class_topic,
  week_topic,
  class_topic_content,
  user_assignment_file,
  question,
  homework_comment,
  note,
  discussion,
  discussionReply,
  directory,
  role,
  faq,
  faq_category,
  tag,
  user_notification,
  homework_reply_comment,
  payment_method_detail,
  module_quiz,
  feedback,
  final_assessment,
  pager_fields,
  user_pager,
  pager_document,
  company,
  industry,
  class_user_status,
});
